export default __webpack_public_path__ + "img/banner-cba9c0ff.png";